var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsuariogenericoActivo36X36(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#69C4DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.75C19.7949 9.75 21.25 11.2051 21.25 13C21.25 14.7949 19.7949 16.25 18 16.25C16.2051 16.25 14.75 14.7949 14.75 13C14.75 11.2051 16.2051 9.75 18 9.75ZM22.75 13C22.75 10.3766 20.6234 8.25 18 8.25C15.3766 8.25 13.25 10.3766 13.25 13C13.25 15.6234 15.3766 17.75 18 17.75C20.6234 17.75 22.75 15.6234 22.75 13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3967 21.7238C19.9068 20.4774 16.0932 20.4774 12.6033 21.7238C12.0916 21.9065 11.75 22.3913 11.75 22.9347V24.2502C11.75 24.9812 12.3975 25.5427 13.1211 25.4394L14.0756 25.303C16.6786 24.9312 19.3214 24.9312 21.9244 25.303L22.8789 25.4394C23.6025 25.5427 24.25 24.9812 24.25 24.2502V22.9347C24.25 22.3913 23.9084 21.9065 23.3967 21.7238ZM12.0988 20.3112C15.9149 18.9483 20.0851 18.9483 23.9012 20.3112C25.0099 20.7071 25.75 21.7574 25.75 22.9347V24.2502C25.75 25.894 24.2941 27.1568 22.6667 26.9243L21.7123 26.7879C19.2499 26.4362 16.7501 26.4362 14.2877 26.7879L13.3333 26.9243C11.7059 27.1568 10.25 25.894 10.25 24.2502V22.9347C10.25 21.7574 10.9901 20.7071 12.0988 20.3112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuariogenericoActivo36X36);
export default __webpack_public_path__ + "static/media/USUARIO GENERICO-ACTIVO_36X36.e7458d7442c985fb227f0399eaa813fd.svg";
export { ForwardRef as ReactComponent };